import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "sugargoo-spreadsheet")!;

export default function SugargooSpreadsheetPage() {
  return <BrandArticle data={data} />;
}